import { HTMLProps, useCallback } from 'react'

type Options = HTMLProps<HTMLAnchorElement>

export function useRedirect() {
  const redirect = useCallback((href: string, options?: Options) => {
    const el = document.createElement('a')

    el.href = href

    if (options) {
      Object.keys(options).forEach(key => {
        el[key] = options[key]
      })
    }

    el.click()
    el.remove()
  }, [])

  return redirect
}
